import React, { PureComponent } from 'react';
import BUTTON from './BUTTON';

class BTNGROUP extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        return <div className="btn-group">
            {Object.keys(this.props.buttons).map((b) => {
                return <BUTTON key={b} onPress={this.props.buttons[b]}><div className="center">{b}</div></BUTTON>
            })}
        </div>;
    }
}

export default BTNGROUP;



// WEBPACK FOOTER //
// ./src/walleris/BTNGROUP.js